import React from 'react';

const Flicker = ({ word, isGlow }) => {
	const getRandomIndexes = (length) => {
		const numFaulty = Math.ceil(length / 3);
		const indexes = new Set();
		while (indexes.size < numFaulty) {
			indexes.add(Math.floor(Math.random() * length));
		}
		return indexes;
	};

	const faultyIndexes = getRandomIndexes(word.length);

	return (
		<span className='flickerCont'>
			<span className={`textFlicker ${isGlow ? 'glow' : ''}`}>
				{word.split('').map((char, index) => (
					<span key={index} className={faultyIndexes.has(index) ? 'faultyFlicker' : ''}>
						{char}
					</span>
				))}
			</span>
		</span>
	);
};

export default Flicker;
